import { debounce } from "lodash-es";
import React, { useEffect, useState } from "react";

import { ClearIcon, SearchBarInput } from "./styled";
import { SearchBarProps } from "./types";

import { SearchIcon } from "~/Atom/SearchIcon";

const debouncedHandleSearchChange = debounce(
  (value, queryDispatch) => {
    queryDispatch({ type: "update_q", value });
  },
  500,
  {
    trailing: true,
  }
);

export const SearchBar: React.FC<SearchBarProps> = ({
  queryState,
  queryDispatch,
}) => {
  const [searchValue, setSearchValue] = useState<string>(
    new URLSearchParams(location.search).get("q") || ""
  );

  useEffect(() => {
    if (queryState.q === "") {
      setSearchValue("");
    }
  }, [queryState]);

  return (
    <SearchBarInput
      id="job-search-bar"
      onChange={(e) => {
        setSearchValue(e.target.value);
        debouncedHandleSearchChange(e.target.value, queryDispatch);
      }}
      placeholder="Search by job title"
      prefix={<SearchIcon />}
      allowClear={{
        clearIcon: <ClearIcon size={24} />,
      }}
      value={searchValue}
    />
  );
};
